const context = {} ;

const refreshListeners = [] ;


const changeHandler = {
    set: function(target, property, value, receiver) {
        if(target[property] === value){ return true ; } 
        
        target[property] = value;
        for(let l of refreshListeners){
            l() ;
        }
        return true;
    }
};

const observedContext = new Proxy(context, changeHandler) ;

observedContext.addRefreshListener = function(listener){
    refreshListeners.push(listener) ;
} ;


export default observedContext ;